import { render, staticRenderFns } from "./Auctions.vue?vue&type=template&id=c9af463e&"
import script from "./Auctions.vue?vue&type=script&lang=js&"
export * from "./Auctions.vue?vue&type=script&lang=js&"
import style0 from "./Auctions.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c9af463e')) {
      api.createRecord('c9af463e', component.options)
    } else {
      api.reload('c9af463e', component.options)
    }
    module.hot.accept("./Auctions.vue?vue&type=template&id=c9af463e&", function () {
      api.rerender('c9af463e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/aduanas/auctions/views/Auctions.vue"
export default component.exports